import type { Region } from './models';
import { RestService, Rest } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class RegionsService {
  private restService = inject(RestService);
  apiName = 'Default';
  

  getRegions = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, Region[]>({
      method: 'GET',
      url: '/api/app/regions/regions',
    },
    { apiName: this.apiName,...config });
}